import { API } from '../../../api';
import { Button, Checkbox, List } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

class LinkTemplates extends React.Component {
  static propTypes = {
    next: PropTypes.func.isRequired,
    setLinkedTemplates: PropTypes.func.isRequired,
  };

  state = {
    checkedOptions: [],
    templateData: [],
  };

  componentDidMount() {
    return this.getTemplates();
  }

  okClicked = () => {
    const { next } = this.props;
    next();
  };

  skipClicked = () => {
    const { next } = this.props;
    next('skip');
  };

  /**
   * When checkbox is checked/unchecked, update the list of checked options.
   */
  onCheckboxChange = (resourceType, namespace, e) => {
    const { setLinkedTemplates } = this.props;
    const { checkedOptions } = this.state;

    const isChecked = e.target.checked;
    const resourceNamespacePair = {
      resourceType,
      namespace,
    };

    if (isChecked) {
      this.setState(
        {
          checkedOptions: [...checkedOptions, resourceNamespacePair],
        },
        () => {
          setLinkedTemplates([...checkedOptions, resourceNamespacePair]);
        },
      );
    } else {
      this.setState(
        {
          checkedOptions: checkedOptions.filter(d => {
            return d.namespace !== namespace || d.resourceType !== resourceType;
          }),
        },
        () => {
          setLinkedTemplates(checkedOptions);
        },
      );
    }
  };

  /**
   * Get resource type and namespace pairs from all mapping
   * templates.
   */
  getTemplates = async () => {
    await API.get('/mapping/templates').then(res => {
      const templateData = res.data.templates;
      templateData.sort((a, b) => {
        if (a.resourceType === b.resourceType) {
          return a.namespace.localeCompare(b.namespace);
        }

        return a.resourceType.localeCompare(b.resourceType);
      });
      this.setState({ templateData });
      return templateData;
    });
  };

  render() {
    const { checkedOptions, templateData } = this.state;
    const checkboxes = [];

    for (let i = 0; i < templateData.length; i += 1) {
      const { resourceType, namespace } = templateData[i];
      const checkboxText = `${resourceType} (${namespace})`;
      const checkboxId = checkboxText.replaceAll(' ', '-').replace('(', '-').replace(')', '-');
      checkboxes.push(
        <List.Item key={checkboxText}>
          <Checkbox
            onChange={e => this.onCheckboxChange(resourceType, namespace, e)}
            id={checkboxId}
            value={checkboxText}
            key={checkboxText}
          >
            {checkboxText}
          </Checkbox>
        </List.Item>,
      );
    }

    return (
      <div style={{ textAlign: 'center' }}>
        <div style={{ marginBottom: 14 }}>
          Would you like to link the file to an existing template? Select any templates below, or
          click &quot;Skip&quot;:
        </div>
        <List bordered style={{ overflow: 'auto', height: 500, marginBottom: 20 }}>
          {checkboxes}
        </List>
        <div>
          <Button
            type="primary"
            onClick={() => this.okClicked()}
            disabled={checkedOptions.length === 0}
          >
            OK
          </Button>
        </div>
        <div>
          <Button primary style={{ marginLeft: '90%' }} onClick={() => this.skipClicked()}>
            Skip
          </Button>
        </div>
      </div>
    );
  }
}

export default LinkTemplates;
